"use client";

import type * as React from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarRail,
} from "@/shadcnComponents/ui/sidebar";
import { NavMain } from "./nav-main";
import { NavUser } from "./nav-user";
import { useAuth } from "@/Providers/Auth";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const authState = useAuth();
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarContent className="pt-2">
        {" "}
        {/* Added padding top */}
        <NavMain />
      </SidebarContent>
      <SidebarFooter>
        <NavUser
          user={{
            name: authState?.loggedBrand?.PocName,
            email: authState?.loggedBrand?.email,
            avatar: "/avatars/shadcn.jpg",
            plan: authState?.loggedBrand?.planName,
          }}
        />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
